var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'banner',
    _vm.type
  ]},[_c('div',{style:({'padding-top': `${_vm.options.padding}`, 'padding-bottom': `${_vm.options.padding}` })},[_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"banner__bar"}),_c('div',{staticClass:"banner__title"},[_c('span',{staticStyle:{"font-family":"'Roboto Bold', sans-serif"}},[_vm._v(_vm._s(_vm.boldTitle))]),_vm._v(_vm._s(_vm.title)+" ")])]),_c('div',{staticClass:"banner__description"},[_vm._v(" "+_vm._s(_vm.description)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }